// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2TzTe","requiredAsterisk":"Info_requiredAsterisk__3E1n4"};